import { render, staticRenderFns } from "./body-settings.vue?vue&type=template&id=09858dae&scoped=true&"
import script from "./body-settings.vue?vue&type=script&lang=js&"
export * from "./body-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09858dae",
  null
  
)

export default component.exports